import { BaseMapper } from '@ps/utils';
import { SupplierDto } from '../dtos/supplier.dto';
import { SUPPLIER_DTO_STATUS } from '../dtos/supplier.constants';
import { Supplier } from '../../models/supplier.model';

export class SupplierMapper extends BaseMapper<SupplierDto, Supplier> {
  public fromDto(dto: SupplierDto): Supplier {
    return {
      id: dto.id,
      name: dto.name,
      blocked: dto.supplrSt === SUPPLIER_DTO_STATUS.BLOCKED,
    };
  }
}
